<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <app-page-header
        [urlName]="'Motivo Desoneração'"
        urlPath="motivo-desoneracao"
    ></app-page-header>

    <p-card class="md:max-w-250">
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Editar/Incluir Motivo Desoneração</h1>

            <div class="w-full grid grid-cols-1 gap-4 items-end">
                <app-input
                    id="descricao"
                    label="Descrição"
                    formControlName="Descricao"
                ></app-input>

                <app-select
                    label="Código"
                    formControlName="CodigoNfe"
                    [options]="selectCodigo"
                ></app-select>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>
